export const messages = {
  en: {
    adminAccountDetail: {
      title: 'Account Details',
      detailId: 'Detail ID',
      orderId: 'Transaction ID',
      acctName: 'Account Name',
      detailType: 'Detail Type',
      detailType1001: 'Transfer In',
      detailType3003: 'Transfer In Revoked',
      detailTypeOther: 'Transfer Out',
      amount: 'Amount/Points',
      createTime: 'Transaction Time',
      remark: 'Remark',
      noRemark: 'None',
      fetchError: 'Failed to fetch account details'
    }
  },
  zh: {
    adminAccountDetail: {
      title: '账户明细',
      detailId: '明细编号',
      orderId: '交易编号',
      acctName: '账户名称',
      detailType: '明细类型',
      detailType1001: '转入',
      detailType3003: '转入已撤销',
      detailTypeOther: '转出',
      amount: '金额/积分',
      createTime: '交易时间',
      remark: '说明',
      noRemark: '无',
fetchError: '获取账户明细失败'
    }
  },
  'zh-TW': {
    adminAccountDetail: {
      title: '賬戶明細',
      detailId: '明細編號',
      orderId: '交易編號',
      acctName: '賬戶名稱',
      detailType: '明細類型',
      detailType1001: '轉入',
      detailType3003: '轉入已撤銷',
      detailTypeOther: '轉出',
      amount: '金額/積分',
      createTime: '交易時間',
      remark: '說明',
      noRemark: '無',
      fetchError: '獲取賬戶明細失敗'
    }
  }
}